export default __webpack_public_path__ + "static/media/black-arrow-down.51da3297.svg";